module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "monitor"
  }, [_c('v-header', {
    attrs: {
      "name": _vm.name,
      "isDashboard": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "left-item left-item1"
  }, [_vm._v("\n          " + _vm._s(_vm.baseName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "left-item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("基地负责人")]), _vm._v(" "), _c('p', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.baseManager))])]), _vm._v(" "), _c('div', {
    staticClass: "left-item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('p', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.contact))])]), _vm._v(" "), _c('div', {
    staticClass: "left-item"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("基地面积")]), _vm._v(" "), _c('p', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.baseArea))])])]), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('v-lines')], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('v-line', {
    attrs: {
      "tit": "无霜期"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('v-lines3')], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('v-lines4')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('v-map', {
    on: {
      "indexChange": _vm.indexChange
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3542d7ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/industryInformation/index.vue
// module id = 1976
// module chunks = 2